<!--
 * @Author       : NN
 * @Date         : 2020-08-04
 * @Description  : 优惠券-领取记录
 -->
<template>
	<div class="fund_manage">
		<a-card title="领取记录" :bordered="false">
			<!-- 搜索 -->
			<div class="search">
				<a-form layout="inline" :form="form">
					<a-form-item>
						<a-select @change="changeIs" v-decorator="['is_use', { initialValue: is_use}]" allowClear placeholder="是否使用" style="width: 195px">
							<a-select-option :value="1">是</a-select-option>
							<a-select-option :value="2">否</a-select-option>
						</a-select>
					</a-form-item>
			
					<a-form-item>
						<a-input @change="changeUser" v-decorator="['user_id', { initialValue: user_id}]" allowClear style="width:300px;" placeholder="请输入用户ID/会员名称/手机号"/>
					</a-form-item>
			
					<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>
			
					<a-form-item><a-button type="primary" html-type="submit" @click="getList">查询</a-button></a-form-item>
				</a-form>
			</div>
			
			<!-- 操作栏 -->
			<div class="handle"><a-button  @click="download('?module=pc_api&action=coupon&app=see_coupon&id='+couponid+'&pageto=')">导出</a-button></div>
			
			<!-- 表格 -->
			<a-table
				:loading="loading"
				:columns="columns"
				:dataSource="dataSource"
				:row-key="record => record.id"
				:pagination="pagination"
				@change="onChangeload"
			>
				<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
			
				<span slot="status" slot-scope="text">
					<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
					<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
					<a-tag v-else color="#969DA8">待上架</a-tag>
				</span>
			
				<span slot="action" slot-scope="text">
					<div>
						<a-button icon="file-search" size="small" @click="onNavJump('coupon/record/1')">领取记录</a-button>
						<a-divider type="vertical" />
						<a-button icon="form" size="small">编辑</a-button>
						<a-divider type="vertical" />
						<a-button icon="delete" size="small">删除</a-button>
					</div>
				</span>
			</a-table>
		</a-card>
		
		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>
		
				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>
		
				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id'
	},
	{
		title: '优惠券名称',
		key: 'name',
		dataIndex: 'name'
	},
	{
		title: '领取人ID',
		key: 'user_id',
		dataIndex: 'user_id'
	},
	{
		title: '领取人名称',
		key: 'user_name',
		dataIndex: 'user_name'
	},
	{
		title: '手机号',
		key: 'mobile',
		dataIndex: 'mobile'
	},
	{
		title: '领取时间',
		key: 'add_time',
		dataIndex: 'add_time'
	},
	// {
	// 	title: '操作',
	// 	key: 'action',
	// 	scopedSlots: { customRender: 'action' }
	// }
];

export default {
	data() {
		return {
			columns,
			form: this.$form.createForm(this, { name: 'deliver' }), // 搜索form
			activeKey: "1",

			// 搜索
			is_use: undefined,
			user_id: '',

			// 表格
			loading: true,
			selectedRowKeys: [],
			selectedRow: [],
			dataSource: [{
				id: 1,
				name: '满100减20',
				type: '满减',
				scope: '全部商品',
				threshold: '满100',
				money: '20元',
				num: 10,
				inventory: 10,
				status: 1,
				valid_time: '2020.08.01-2020.08.08',
			}],
			pagination: {},
			
			// 导出
			visible1: false,
			urls: '',
			
			couponid: ''
		};
	},
	created() {
		this.couponid = this.$route.params.id
		this.getList()
	},
	methods: {
		changeIs(e){
			this.is_use = e
		},
		changeUser(e){
			this.user_id = e.target.value
		},
		/**
		 * @name 导出
		 */
		onDownload(pageto) {
			this.visible1 = false
			
			if (pageto != 'whole') {
				this.form.validateFields((err, values) => {
					if (!err) {
						values.name = values.user_id
						values.status = values.is_use
						let data = { ...values , page: this.pagination.current};
						this.$request.download(this.urls + pageto, data);
					}
				});
				return;
			}
			
			this.$request.download(this.urls + pageto);
		},
		/**
		 * @name 导出
		 * */
		
		download(refnamm) {
			this.urls = refnamm;
			this.visible1 = !this.visible1;
		},
		/**
		 * @name 路由跳转
		 */
		onNavJump(url){
		  this.$router.push(url)
		},
		resetGoods() {
			this.is_use = undefined
			this.user_id = ''
			
			this.form.setFieldsValue({
				is_use: undefined,
				user_id: '',
			});
		},
		onSelectChange(selectedRowKeys, selectedRow) {
			this.selectedRowKeys = selectedRowKeys;
			this.selectedRow = selectedRow;
		},
		onChangeload(pagination) {
			this.getList({ page: pagination.current, ...pagination });
		},
		/**
		 * @name 请求列表
		 */
		getList(page = {}, current = 1) {
			this.loading = true;

			let data = {
				id: this.$route.params.id,
				name: this.user_id,
				status: this.is_use,
				...page
			};
			let url = '?module=pc_api&action=coupon&app=see_coupon';

			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.dataSource = data.list
					
					let pages = {
					  total: data.total ,
					  current: page.page || current
					}
					this.pagination = pages
				}else{
					this.$message.error(message)
				}
				
				this.loading = false
			});
		}
	}
};
</script>
<style lang="less">
.fund_manage {
	position: relative;
	min-height: 100%;
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	
	.ant-card-body{
		padding: 0
	}
}
.derive {
  height: 200px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  > div {
    width: 100px;
    height: 100px;
    border: 1px solid #03a2f4;
    border-radius: 4px;
    color: #03a2f4;
    font-size: 14px;
    transition: background-color 0.5s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
  }

  > div:hover {
    border: 0px solid #03a2f4;
    color: #ffffff;
    background: #2890ff;
  }
}
</style>
